import { ErrorCode } from '@ancon/wildcat-types'
import isSerializedCodedError from '@ancon/wildcat-utils/error/isSerializedCodedError'

/**
 * Whether the poller rejected a worker because its `maxLifeTimeMillis` ran
 * out. The poller uses the generic Hangfire code for this and for its own
 * failures, so only the message tells it apart.
 */
function isHangfireWorkerLifetimeExceededError(error: unknown): boolean {
  return (
    isSerializedCodedError(error, ErrorCode.GenericUnexpectedHangfireError) &&
    error.message === 'The Hangfire worker lifetime has been exceeded'
  )
}

export default isHangfireWorkerLifetimeExceededError
